import * as actionType from "../../../context/actions";
import GetCustomersData from "../../Comman/GetCustomersData";
import GetEarnings from "../../Comman/GetEarnings";
import GetSoldItemsData from "../../Comman/GetSoldItesmData";

const GetExpenseDataLocal = async (state, dispatch) => {
    try {

        const EXPENSE_DATA = localStorage.getItem("LOCAL_EXPENSE");

        if (EXPENSE_DATA) {
            const data = Object.entries(JSON.parse(EXPENSE_DATA)).map(([key, item]) => [
                key,
                {
                    localId: (new Date().getTime() / 1000).toFixed(0),
                    id: key,
                    srNo: 1, // You can modify this if needed
                    ...item
                }
            ]);


            const formattedData = Object.entries(data).map(([localId, info]) => ({
                ...info[1],
            }));


            const sortedExpenseData = formattedData.sort((a, b) => b.id - a.id)
                .map((item, index) => ({
                    srNo: index + 1, // Assign serial number after sorting
                    ...item,
                }));
               
                

            dispatch({ type: actionType.EXPENSE, payload: sortedExpenseData });
        
            
            return sortedExpenseData;
        }
        else {
            dispatch({ type: actionType.EXPENSE, payload: [] });
            return []
        }


    } catch (error) {
        console.error("Error fetching company data:", error);
        return null;
    }
};

export default GetExpenseDataLocal;